import { useEffect, useState } from 'react'
import { useSWRConfig } from 'swr'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import axios from '../../services/api'
import BranchesCategoryForm from '../../components/Forms/BranchesCategoryForm'
import PageTitle from '../../components/UI/PageTitle'
import { useAuthContext } from '../../context/auth/auth'
import { toast } from 'react-toastify'

const CreateCategory = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { t } = useTranslation()
  const { mutate } = useSWRConfig()
  const { authClient, token } = useAuthContext()
  const navigate = useNavigate()

  const onSubmit = async (values: { title: string }) => {
    try {
      setIsLoading(true)
      const response = await axios.post(
        '/report/category/',
        {
          title: values.title,
          organization: authClient?.organization,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (response.status === 201) {
        toast.success(t('categoryHasBeenCreated'))
        mutate('categories')
        navigate(-1)
        setIsLoading(false)
      }
    } catch (error) {
      toast.error(t('failedToCreateCategory'))
      setIsLoading(false)
    }
  }

  useEffect(() => {
    document.title = `${t('newCategory')} - ReportAll`
  }, [t])

  return (
    <>
      <PageTitle title={t('newCategory')} />
      <BranchesCategoryForm
        onSubmit={onSubmit}
        isLoading={isLoading}
        label='category'
        buttonText='newCategory'
      />
    </>
  )
}

export default CreateCategory
